import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const IndustryHero = ({ title, intro, description, primaryCta, secondaryCta }) => {
   return (
      <section className="industry-hero p-relative fix" style={{ background: `url(assets/img/page-title/page-title-1.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
         <div className="tw-container tw-mx-auto p-relative">
            <div className="tw-flex tw-flex-wrap tw--mx-3">
               <div className="tw-w-full tw-px-3 lg:tw-w-9/12">
                  <div className="industry-hero__content">
                     <h1>{title}</h1>
                     <p className="industry-hero__intro">{intro}</p>
                     <p className="industry-hero__desc">{description}</p>
                     <div className="industry-hero__ctas">
                        <Link to={primaryCta.to} className="btn-more">
                           <span className="btn-text">{primaryCta.label}</span>
                           <span className="btn-icon" aria-hidden="true">
                              <ArrowUpRight size="16px" className="icon" />
                           </span>
                        </Link>
                        {secondaryCta && (
                           <Link to={secondaryCta.to} className="z-btn z-btn-border">{secondaryCta.label}</Link>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default IndustryHero;
